import React from 'react'
import { NoticeLoading } from '@fs/zion-icon'
import { css } from '@emotion/core'

export default function LoadingSpinner({ size = 'md' }) {
  const center = css`
    position: fixed;
    top: 50%;
    inset-inline-start: 50%;
    transform: translate(-50%, -50%);
  `

  return (
    <div data-testid="spinner" css={center}>
      <NoticeLoading size={size} />
    </div>
  )
}
